import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { tap, map } from 'rxjs/operators';

import * as RouterActions from '../actions/router.action';

@Injectable()
export class RouterEffects {
    navigate$
    navigateBack$: any;
    navigateForward$: any;
    constructor(
        private actions$: Actions,
        private router: Router,
        private location: Location
    ) {
        // Navigate
        this.navigate$ = createEffect(() =>
            this.actions$.pipe(
                ofType(RouterActions.GO),
                map((action: RouterActions.Go) => action.payload),
                tap(({ path, query: queryParams, extras }) => {
                    this.router.navigate(path, { queryParams, ...extras });
                })
            ),
            { dispatch: false }
        );

        // Navigate back
        this.navigateBack$ = createEffect(() =>
            this.actions$.pipe(
                ofType(RouterActions.BACK),
                tap(() => this.location.back())
            ),
            { dispatch: false }
        );

        // Navigate forward
        this.navigateForward$ = createEffect(() =>
            this.actions$.pipe(
                ofType(RouterActions.FORWARD),
                tap(() => this.location.forward())
            ),
            { dispatch: false }
        );
    }


}
